export default function getCurrentWeekRange() {
  const currentDate = new Date();
  const startOfWeek = new Date(
    // Make sure to get the first day of the week as Monday to match DB counter
    currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1),
  );
  const endOfWeek = new Date(
    currentDate.setDate(currentDate.getDate() + 7 - currentDate.getDay()),
  );
  return {
    startOfWeek: startOfWeek.toISOString().split('T')[0],
    endOfWeek: endOfWeek.toISOString().split('T')[0],
  };
}
